module.exports = __webpack_public_path__ + "img/portraits_19_V.04686986.webp";